import i18n from '@/main';
import NotificationService from '@/services/NotificationService';
import { TIPO_PLANILHA_OPERACAO } from '@/constants/tipoPlanilhaOperacao';

/**
 * Notificações da fila única de planilhas de operação (type PLANILHA_OPERACAO).
 * O metadata.tipoPlanilha indica para qual tela o usuário é levado.
 * O título e a mensagem já chegam traduzidos do backend, no idioma do upload.
 */
const TELAS_POR_TIPO = {
    [TIPO_PLANILHA_OPERACAO.INIBICAO_ALERTAS]: {
        rota: '/operacao/inibicao-lote',
        chaveCategoria: 'mensagens.planilhaOperacao.notificacao.categoria.inibicaoEmLote'
    },
    [TIPO_PLANILHA_OPERACAO.ALTERACAO_OPERACOES]: {
        rota: '/operacao/alteracao-lote',
        chaveCategoria: 'mensagens.planilhaOperacao.notificacao.categoria.alteracaoEmLote'
    }
};

class PlanilhaOperacaoNotificationHandler {
  static handleNotification(notification) {
    if (!notification || notification.type !== 'PLANILHA_OPERACAO') return;

    const metadata = notification.metadata || {};
    const tela = TELAS_POR_TIPO[metadata.tipoPlanilha];
    if (!tela) return;

    const notificationObj = {
        id: `planilha_operacao_${metadata.arquivoId}`,
        type: 'PLANILHA_OPERACAO',
        status: notification.status,
        title: notification.title,
        message: notification.message,
        category: i18n.t(tela.chaveCategoria),
        timestamp: notification.timestamp,
        metadata,
        actions: [{
            label: i18n.t('mensagens.planilhaOperacao.notificacao.verPlanilhas'),
            icon: 'el-icon-document',
            type: notification.status === 'PROCESSADO' ? 'primary' : 'danger',
            handler: (vm) => {
                if (vm && vm.$router && vm.$route?.path !== tela.rota) {
                    vm.$router.push(tela.rota);
                }
            }
        }]
    };

    NotificationService.addNotification(notificationObj);
  }

  static initializeListener() {
    window.addEventListener('generic-notification', (event) => {
        this.handleNotification(event.detail);
    });
  }
}

export default PlanilhaOperacaoNotificationHandler;
